import { render } from "./CitationCard.component.vue?vue&type=template&id=5551f935&scoped=true"
import script from "./CitationCard.component.vue?vue&type=script&lang=js"
export * from "./CitationCard.component.vue?vue&type=script&lang=js"

import "./CitationCard.component.vue?vue&type=style&index=0&id=5551f935&scoped=true&lang=css"

import exportComponent from "/home/debian/oni-ui/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5551f935"]])

export default __exports__